module.exports = __webpack_public_path__ + "img/next.cc045a7a.svg";